import Cobre from '../images/productos/cobre.webp'
import Cable from '../images/productos/cable.webp'
import Gas from '../images/productos/gas.webp'
import Latas from '../images/productos/latas.webp'
import Placas from '../images/productos/placa.webp'
import Aceites from '../images/productos/aceite.webp'
import Aislantes from '../images/productos/aislante.webp'
import Termostato from '../images/productos/termostato.webp'
import Manifolds from '../images/productos/manifold.webp'
import Valvulas from '../images/productos/valvulas.webp'
import Filtros from '../images/productos/filtros.webp'
import Motocompresores from '../images/productos/motocompresor.webp'

export const insumosData = [
    {
        "title": "Cobre",
        "text": "Caños, cuplas, curvas y codos. Lo que necesites para hacer el trazado de tu instalación",
        "textButton": "Ir a Cobre",
        "src": Cobre, 
        "alt": "Cobre",
        "link": "cobre"
    },
    {
        "title": "Garrafas",
        "text": "Gas refrigerante en presentaciones de 3 a 13.6Kg. Gases R22, R134, R410, R404 y otros",
        "textButton": "Ir a Cobre",
        "src": Gas, 
        "alt": "Gas refrigerante",
        "link": "gas"
    },
    {
        "title": "Latas",
        "text": "Latas de gas refrigerante y agentes de limpieza para trabajos pequeños. Gases R22, R134, R410, R404 y otros",
        "textButton": "Ir a Cobre",
        "src": Latas, 
        "alt": "Latas de gas refrigerante",
        "link": "lata"
    },
    {
        "title": "Aislantes",
        "text": "Tiras aislantes para caño de cobre. Medidas desde 1/4 hasta 7/8",
        "textButton": "Ir a Cobre",
        "src": Aislantes, 
        "alt": "Aislantes de caño",
        "link": "arma"
    },
    {
        "title": "Filtros",
        "text": "Filtros familiares y comerciales. Multiples medidas, tanto para soldar como para conexión flare",
        "textButton": "Ir a Cobre",
        "src": Filtros, 
        "alt": "Filtro",
        "link": "filtro"
    },
    {
        "title": "Motocompresores",
        "text": "Motocompresores para heladeras, freezers y aire acondicionado. Para gases R134, R410 y R22/404",
        "textButton": "Ir a Cobre",
        "src": Motocompresores, 
        "alt": "Motocompresores",
        "link": "motoc"
    },
    {
        "title": "Válvulas",
        "text": "Válulas de servicio, válvulas inversoras, válvulas de expansión y demás",
        "textButton": "Ir a Cobre",
        "src": Valvulas, 
        "alt": "Cobre",
        "link": "valv"
    },
    {
        "title": "Termostatos",
        "text": "Termostatos familiares y comerciales. Para heladeras, enfriadoras, freezers y cámaras",
        "textButton": "Ir a Cobre",
        "src": Termostato, 
        "alt": "Termostato",
        "link": "termostato"
    },
    {
        "title": "Placas universales",
        "text": "Placas universales con control remoto para aire acondicionado. Modelos con y sin PG",
        "textButton": "Ir a Cobre",
        "src": Placas, 
        "alt": "Placas de aire acondicionado",
        "link": "placa"
    },
    {
        "title": "Cables",
        "text": "Cables TPR de la medida que necesites para hacer el trazado de tu instalación",
        "textButton": "Ir a Cobre",
        "src": Cable, 
        "alt": "Cables TPR",
        "link": "cable"
    },
    {
        "title": "Aceites",
        "text": "Aceites para refrigeración ISO 68 e ISO 32, en diferentes marcas y presentaciones",
        "textButton": "Ir a Cobre",
        "src": Aceites, 
        "alt": "Aceites para refrigeración",
        "link": "aceite"
    },
    {
        "title": "Manifolds",
        "text": "Manifolds para comenzar a realizar trabajos de refrigeración. Tanto solos como en kit con otras herramientas",
        "textButton": "Ir a Cobre",
        "src": Manifolds, 
        "alt": "Cobre",
        "link": "manifold"
    },
]
